import { envConfig } from 'constants/envConfig';
import { SiteId, MATOMO_SCRIPT_ID, JS_FILENAME, PHP_FILENAME } from './contants';

interface IExperiment {
    name: string;
    variation: string;
}

export const getSiteId = (): number => {
    if (envConfig.isLocalEnv) {
        return SiteId.LOCAL;
    }

    if (envConfig.isDemoEnv) {
        return SiteId.DEMO;
    }

    if (!envConfig.isProductionEnv) {
        return SiteId.STG;
    }

    return SiteId.PROD;
};

const loadExperiments = (): Promise<Record<string, string>> =>
    Promise.all([] as IExperiment[]).then((experiments) =>
        experiments.reduce((acc, experiment) => {
            acc[experiment.name] = experiment.variation;
            return acc;
        }, {} as Record<string, string>),
    );

export const pushEvent = (args: (string | number | Record<string, unknown>)[]): void => {
    if (!window._paq) {
        window._paq = [];
    }

    window._paq.push(args);
};

export const loadMatomo = (): Promise<Record<string, string>> =>
    new Promise((resolve) => {
        if (typeof window === 'undefined') {
            throw new Error('Matomo service cannot be initialized. Window is not defined');
        }

        if (document.getElementById(MATOMO_SCRIPT_ID)) {
            return;
        }

        pushEvent(['setSiteId', getSiteId()]);
        pushEvent(['setTrackerUrl', PHP_FILENAME]);

        const scriptElement = document.createElement('script');
        const refElement = document.getElementsByTagName('script')[0];

        Object.assign(scriptElement, {
            id: MATOMO_SCRIPT_ID,
            type: 'text/javascript',
            defer: false,
            async: false, // For AB testing matomo should be loaded synchronously
            onerror: resolve,
            onload: () => {
                // Init A/B testing
                if (typeof Piwik === 'object' && typeof Piwik.AbTesting === 'object') {
                    loadExperiments().then(resolve);
                } else {
                    window.piwikAbTestingAsyncInit = () => loadExperiments().then(resolve);
                }
            },
            src: JS_FILENAME,
        });

        refElement.parentNode.insertBefore(scriptElement, refElement);
    });
